export default __webpack_public_path__ + "static/media/copy.2e3c36ba.svg";